namespace advisorop.services {
    `use strict`;

    export class AdvisorPpService {
        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        requestActivities(activitiesRequest: domains.IActivitiesRequest): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/pp/activities`, activitiesRequest);
        };

        requestHoldings(holdingsRequest: domains.IHoldingsRequest): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/pp/holdings`, holdingsRequest);
        };

        checkSso(): ng.IHttpPromise<any> {
            return this.$http.get(`/api/advisor/pp/checksso`);
        };

        setupSso(ssoData: any): ng.IHttpPromise<any> {
            return this.$http.post(`/api/advisor/pp/setupsso`, ssoData);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service(`advisorPpService`, AdvisorPpService);
}
